'use strict';

var log = require('../../log/Log').channel('RoomPasswordService');
var sutl = require('../../sutl/Sutl');

angular.module('inara')
.provider('RoomPasswordService', function() {
    var options = {
        timeout: 0,
        resetTimeoutEvents: 'mousemove keydown DOMMouseScroll mousewheel ' +
            'mousedown touchstart touchmove touchrepeat scroll'
    };

    this.timeout = function(seconds) {
        if (seconds === false) {
            options.timeout = 0;
        } else if (angular.isNumber(seconds) && seconds >= 0) {
            options.timeout = seconds;
        } else {
            throw new Error('timeout must be >= 0 or false');
        }
    };

    this.resetTimeoutEvents = function(events) {
        options.wakeEvents = events;
    };

    this.$get = ['$rootScope', '$timeout', '$window', '$document',
        'RoomService', 'KayleeService', RoomPasswordService];

    function RoomPasswordService($rootScope, $timeout, $window, $document,
        RoomService, KayleeService) {
        var STARTING = 0, UNLOCKED = 1, LOCKED = 2, DISABLED = 3;
        var lockTimeoutPromise = null;
        var serviceState = STARTING;
        var room = null;

        log.info('initializing');

        $document.find('html').on(options.resetTimeoutEvents, function(event) {
            if (serviceState === UNLOCKED &&
                (event.type !== 'mousemove' || 
                angular.isUndefined(event.movementX) || 
                (event.movementX || event.movementY))) {
                resetLockTimeout();
            }
        });

        RoomService.onOnlineChanged(onRoomServiceOnlineChanged);

        return {
            isLocked: isLocked,
            isSupported: isSupported,
            lock: lock,
            unlock: unlock
        };

        function cancelLockTimeout() {
            if (lockTimeoutPromise) {
                $timeout.cancel(lockTimeoutPromise);
                lockTimeoutPromise = null;
            }
        }

        function enable(shouldEnable) {
            if (serviceState !== STARTING &&
                (shouldEnable && serviceState !== DISABLED ||
                !shouldEnable && serviceState === DISABLED)) {
                return;
            }
            serviceState = STARTING; // required for unlock() and lock() to work
            if (!shouldEnable) {
                cancelLockTimeout();
                // Prevent call to $apply when enabling/disabling since $digest
                // will already be in progress.
                unlock(true);
                serviceState = DISABLED;
            } else {
                lock();
            }
        }

        function isLocked() {
            return serviceState === LOCKED;
        }

        function isSupported() {
            return angular.isDefined($window.cordova) ||
                RoomService.isUiPreview() ||
                KayleeService.isInitialized() &&
                KayleeService.isAuthenticatedAsAnonymousRemoteControl();
        }


        function lock() {
            if (!isSupported() || serviceState === LOCKED || serviceState === DISABLED) return;
            log.debug('lock()');
            serviceState = LOCKED;
            var keyboard = sutl.getNode($window, 'cordova.plugins.Keyboard');
            if (keyboard !== null) keyboard.close();
            $rootScope.$broadcast('RoomPasswordService', 'locked');
        }

        function onRoomChanged() {
            var enabled = angular.isString(room.settings.userPassword) &&
                room.settings.userPassword.length > 0;
            enable(enabled);
            if (room.settings.userPasswordTimeoutSec !== options.timeout) {
                options.timeout = room.settings.userPasswordTimeoutSec;
                if (enabled) resetLockTimeout();
            }
        }

        function onRoomServiceOnlineChanged(online) {
            if (online) {
                room = RoomService.getRoom();
                room.$onChange(onRoomChanged);
            } else if (room !== null) {
                room.$offChange(onRoomChanged);
                room = null;
                enable(false);
            }
        }

        function resetLockTimeout() {
            cancelLockTimeout();
            if (options.timeout > 0 && isSupported()) {
                lockTimeoutPromise = $timeout(lock, options.timeout * 1000);
            }
        }

        function unlock(noApply) {
            if (serviceState === DISABLED) return;
            resetLockTimeout();
            if (serviceState === UNLOCKED) return;
            log.debug('unlock()');
            if (noApply === true) {
                serviceState = UNLOCKED;
            } else {
                $rootScope.$apply(function() {
                    serviceState = UNLOCKED;
                });
            }
            $rootScope.$broadcast('RoomPasswordService', 'unlocked');
        }
    }
});